import * as Sentry from '@sentry/react';

const sentryConfig = {
  dsn: 'https://7919425df7828adce15f95ea18193687@o4507529654173696.ingest.de.sentry.io/4508463042854992',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['eroplay.ai', 'eroplay-test.me'],
  enableSourceMaps: true
};

export default Sentry.init(sentryConfig);